<ul class="layout-tabmenu-nav">
    <li class="sidebar-group">
        <mat-button-toggle-group #ladderViewModeGroup="matButtonToggleGroup" (change)="onViewModeChange($event)"
            [vertical]="true">
            <mat-button-toggle [hidden]="!isReportDashboardDesigner" class="dashboardOptionSidebar" value="DESIGN"
                [checked]="viewMode == 'DESIGN'" matTooltip="Design" matTooltipPosition="right">
                <mat-icon>settings</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle [hidden]="!isReportDashboardViewer" class="dashboardOptionSidebar" value="VIEW"
                [checked]="viewMode == 'VIEW'" matTooltip="View" matTooltipPosition="right">
                <mat-icon>slideshow</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
</ul>